export default __webpack_public_path__ + "static/media/Create-account-BG.e197cb8c.png";